import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Logo3D from "@/components/hud/Logo3D";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-6 bg-app">
        <Logo3D size={120} />
        <div className="font-mono text-xs tracking-[0.3em] text-cyan/70 animate-pulse-glow">
          ESTABLISHING UPLINK...
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}
